import React, { useEffect, useState } from "react";
import "swiper/css";
import "swiper/css/free-mode";
import { motion, AnimatePresence } from "framer-motion";
import { currencyDisplay } from "../helpers/commonHelper";

const StockDetailsWithProducts = ({ onBack, stockSummary }) => {
  const [clientData, setClientData] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [productsStock, setProductsStock] = useState([]);
  const [search, setSearch] = useState("");

  const filteredProducts =
    productsStock && productsStock.length > 0
      ? productsStock.filter((item) => {
          const q = search.toLowerCase();

          return (
            item.product?.toLowerCase().includes(q) ||
            item.barcode?.toLowerCase().includes(q) ||
            item.productCode?.toLowerCase().includes(q)
          );
        })
      : [];

  

  useEffect(() => {
    const data = sessionStorage.getItem("clientSettings");
    if (data) setClientData(JSON.parse(data));
  }, []);

  return (
    <div className="w-full h-[100dvh] flex flex-col relative bg-white">
      <div className="sticky top-0 z-20 bg-white px-4 pt-4 pb-2 border-b border-gray-200">
        <div
          className="absolute top-4 left-4 bg-white p-2  cursor-pointer"
          onClick={onBack}
        >
          <i className="ri-arrow-go-back-fill text-[20px] text-gray-600 hover:text-indigo-600"></i>
        </div>

        <div className="pl-14">
          <h1 className="text-lg sm:text-3xl font-QBold text-gray-800">
            {stockSummary.locationName}
          </h1>
          <h2 className="text-sm sm:text-xl font-QSemiBold text-gray-600">
            {" "}
            Stock Report
          </h2>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto px-4 pt-2 x bg-white">
        <div className="space-y-3 pb-44">
          {stockSummary.stock.map((dept, index) => (
            <div
              key={index}
              className="p-3 sm:p-4 bg-gradient-to-r from-gray-50 to-white rounded-lg border border-gray-200"
            >
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 sm:gap-4">
                {/* Department Name */}
                <div className="flex items-center justify-between flex-1 min-w-0">
                  <h3 className="font-QBold text-gray-800 truncate text-sm sm:text-base">
                    {dept.department}
                  </h3>
                  <button
                    onClick={() => {
                      setOpenDrawer(true);
                      setProductsStock(dept?.productsStock);
                    }}
                    className="bg-indigo-600 text-white px-4 py-2 rounded-lg text-xs sm:text-sm font-QSemiBold shadow-md hover:scale-105 transition"
                  >
                    Product Stock
                  </button>
                </div>

                {/* Stock & Value */}
                <div className="flex flex-col sm:flex-row sm:space-x-6 space-y-1 sm:space-y-0">
                  <div className="flex sm:flex-col justify-between sm:justify-start">
                    <div className="text-xs text-gray-500 font-QMedium sm:mb-1">
                      STOCK
                    </div>
                    <div
                      className={`font-mono text-sm sm:text-base font-QSemiBold ${
                        dept.stock < 0 ? "text-red-600" : "text-indigo-600"
                      }`}
                    >
                      {dept.stock.toLocaleString()}
                    </div>
                  </div>

                  <div className="flex sm:flex-col justify-between sm:justify-start">
                    <div className="text-xs text-gray-500 font-QMedium sm:mb-1">
                      VALUE
                    </div>
                    <div className="font-mono text-sm sm:text-base font-QSemiBold text-green-600">
                      {clientData?.mainCurrencyName}{" "}
                      {currencyDisplay(dept.stockValue)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ========== Bottom Drawer ========== */}
      <AnimatePresence>
        {openDrawer && (
          <>
            {/* Overlay */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.4 }}
              exit={{ opacity: 0 }}
              onClick={() => setOpenDrawer(false)}
              className="fixed inset-0 bg-black z-40"
            />

            {/* Drawer */}
            <motion.div
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              transition={{ type: "spring", stiffness: 120, damping: 18 }}
              className="fixed bottom-0 left-0 right-0 z-50 bg-white rounded-t-3xl shadow-2xl h-[80dvh] flex flex-col"
            >
              {/* Handle */}
              <div className="flex justify-center py-3">
                <div className="w-14 h-1.5 bg-gray-300 rounded-full" />
              </div>

              {/* Header */}
              <div className="px-5 pb-3 border-b border-gray-200 flex justify-between">
                <h3 className="text-lg font-QBold text-gray-800">
                  Product Stock Details
                </h3>
                <button
                  onClick={() => setOpenDrawer(false)}
                  className="text-gray-500 font-QBold text-sm"
                >
                  Close
                </button>
              </div>

              {/* Search Bar */}
              <div className="px-5 py-3 border-b bg-white sticky top-0 z-10">
                <div className="relative">
                  <input
                    type="text"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Search by product, barcode, code..."
                    className="w-full pl-10 pr-4 py-2 rounded-xl font-QRegular border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm"
                  />
                  <i className="ri-search-line absolute left-3 top-2.5 text-gray-400"></i>
                </div>
              </div>

              <div className="flex-1 overflow-y-auto px-5 py-4 space-y-4 pb-44">
                {filteredProducts.length === 0 ? (
                  <div className="flex flex-col items-center justify-center py-16 text-gray-400">
                    <i className="ri-inbox-archive-line text-5xl mb-3"></i>
                    <p className="text-sm font-QSemiBold">No products found</p>
                    <p className="text-xs font-QRegular">
                      Try searching by product, barcode or code
                    </p>
                  </div>
                ) : (
                  filteredProducts.map((item, i) => {
                    const isNegative = item.stock < 0;

                    return (
                      <motion.div
                        key={i}
                        initial={{ opacity: 0, y: 40, scale: 0.96 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        transition={{ delay: i * 0.05, type: "spring" }}
                        className="relative overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm"
                      >
                        {/* Top Accent Bar */}
                        <div
                          className={`h-1.5 w-full ${
                            isNegative ? "bg-red-500" : "bg-indigo-500"
                          }`}
                        />

                        <div className="p-4 space-y-3">
                          {/* Product Name */}
                          <div className="flex justify-between items-start">
                            <div>
                              <h4 className="text-base font-QBold text-gray-800">
                                {item.product}
                              </h4>
                              <div className="text-xs text-gray-500 mt-1">
                                Department:{" "}
                                <span className="font-QSemiBold text-gray-700">
                                  {item.department}
                                </span>
                              </div>
                            </div>
                          </div>

                          {/* Barcode + Code */}
                          <div className="flex flex-wrap gap-2">
                            <span className="px-2 py-1 text-xs bg-gray-100 rounded-md font-QSemiBold text-gray-600">
                              Barcode: {item.barcode}
                            </span>
                            <span className="px-2 py-1 text-xs bg-gray-100 rounded-md font-QSemiBold text-gray-600">
                              Code: {item.productCode}
                            </span>
                          </div>

                          {/* Stock & Value */}
                          <div className="flex justify-between items-end pt-2 border-t">
                            <div>
                              <div className="text-xs text-gray-500">
                                Available Qty
                              </div>
                              <div
                                className={`text-lg font-mono font-QBold ${
                                  isNegative
                                    ? "text-red-600"
                                    : "text-indigo-600"
                                }`}
                              >
                                {item.stock}
                              </div>
                            </div>

                            <div className="text-right">
                              <div className="text-xs text-gray-500">
                                Stock Value
                              </div>
                              <div className="text-green-600 font-QSemiBold">
                                {clientData?.mainCurrencyName}{" "}
                                {currencyDisplay(item.stockValue)}
                              </div>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    );
                  })
                )}
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default StockDetailsWithProducts;
